<template>
	<v-select
		v-model="domainId"
		v-bind="$attrs"
		:label="$gettext('Domain')"
		:items="domains"
		item-title="name"
		item-value="id"
	/>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
export default {
	name: 'DomainSelect',
	props: {
		modelValue: {
			type: [Number, null, ],
			required: false,
			default: null,
		}
	},

	emits: ['update:modelValue',],

	data () {
		return {
			domainId: null,
			domains: [],
		};
	},

	watch: {
		/**
		 * Watch
		 */
		domainId: {
			/**
			 * Update address in parent components
			 */
			handler () {
				this.$emit('update:modelValue', this.domainId);
			},
		}
	},

	mounted () {
		this.getDomains();
	},

	methods: {
		/**
		 * @returns {void}
		 */
		getDomains () {
			axios.get('/api/v0/domains')
				.then(({
					data: domains
				}) => {
					this.domains = domains;
					this.domainId = this.modelValue ? this.modelValue : domains[0].id;
				});
		},
	}
};
</script>
